import { SegmentPageProperties, SegmentTagV2 } from '../shared/analytics/models/segment-tag.model'
import { Injectable } from '@angular/core'
import { SegmentService } from '../shared/analytics/services/segment.service'

/**
 * The standard Page tag for the video list page view.
 *
 * @remarks
 * This is expected to be used with pageV2, as indicated by the use of the
 * SegmentTagV2 interface and `autoPageCall: false`.
 *
 * @see SegmentService#pageV2
 */
export const VIDEO_TAG: SegmentTagV2 = {
  page_category: 'Video',
  category: 'Videos',
  node_type: 'Video',
  autoPageCall: false
}

interface VideoDetailAnalyticsProps {
  // The Node ID
  id: number
  is_premium: boolean
  content_tags: string | undefined
  primary_association_id: number | undefined
}

function videoDetailProps(video: VideoDetailAnalyticsProps): SegmentPageProperties {
  return {
    _tag: 'entity',
    node_id: video.id,
    is_premium: video.is_premium,
    content_tags: video.content_tags,
    primary_association_id: video.primary_association_id
  }
}

@Injectable()
export class VideosAnalyticsService {
  constructor(private readonly segment: SegmentService) {}

  public pageVideoDetail(props: VideoDetailAnalyticsProps): void {
    this.segment.pageV2(VIDEO_TAG, videoDetailProps(props))
  }
}
